import Vue from "vue";
import Router from "vue-router";

import routes from "./routes";

Vue.use(Router);

const pageStartTime = {};

const router = new Router({
  mode: "history",
  routes,
});

router.afterEach((to, from) => {
  const now = parseInt(new Date().valueOf() / 1000);

  if (!pageStartTime[to.path]) {
    pageStartTime[to.path] = now;
  }

  if (from.path != to.path) {
    window.scrollTo(0, 0);

    if (pageStartTime[from.path]) {
      const diff = now - pageStartTime[from.path];
      pageStartTime[from.path] = "";

      Vue.prototype.$gtag.event("Page", {
        event_category: "Duration",
        event_label: from.path,
        value: diff,
      });
    }
  }
});

export default router;
